<template>
    <div v-show="mobile() || isActive" :class="{infoContent: true, mobile: mobile(), active: isActive}">
        <div class="headline" @click="active = !active">
            <img v-show="mobile() && !isActive" src="@/assets/christmas/collapse_closed.svg" class="collapseIcon">
            <img v-show="mobile() && isActive" src="@/assets/christmas/collapse_open.svg" class="collapseIcon">
            <h3 class="title">{{ title }}</h3>
        </div>

        <div v-show="isActive" class="infoText">
            <slot></slot>
        </div>
        <span class="separator" v-show="mobile() && info[index].lastOfType"></span>

    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import {Prop} from "vue-property-decorator";
    import BasicComponent from "@/components/BasicComponent";


    @Component()
    export default class InfoContent extends BasicComponent {

        @Prop(Array) info;
        @Prop(Number) index;
        @Prop(Number) activeIndex;

        data() {
            return {
                active: false
            };
        }

        setActive(value) {
            this.$data.active = value;
        }

        get title() {
            return this.info[this.index].title;
        }

        get isActive() {
            return this.mobile() ? this.$data.active : this.index === this.activeIndex;
        }

    }
</script>
<style scoped lang="scss">

    .headline {
        text-align: left;

        .collapseIcon {
            margin-right: 5px;
            display: inline-block;
        }

        .title {
            font-weight: bold;
            color: #000336;
            margin-bottom: 10px;
            display: inline-block;
        }
    }


    .infoText {
        text-align: left;
        color: black;
        font-weight: normal;
        margin-bottom: 10px;
        line-height: 1.8;
    }

    b {
        font-weight: 600 !important;
    }

    br {
        content: " ";
        display: block;
        margin: 20px 0;
    }

    .separator {
        &::after {
            content: " ";
            display: block;
            margin-top: 10px;
            margin-bottom: 10px;
            border-bottom: 1px solid #707070;
        }
    }

</style>
